// Session view navigation tabs
export const TABS = {
  ASSISTANT: "assistant",
  AGENDA: "agenda",
  ACTION_ITEMS: "actionItems",
};

// View states for the main container
export const VIEWS = {
  MAIN: "main",
  SUMMARIES: "summaries",
  SUMMARY_DETAIL: "summaryDetail",
  SETTINGS: "settings",
};

// Chatbot message types
export const CHATBOT_MESSAGE_TYPE = {
  INCOMING: "incoming",
  OUTGOING: "outgoing",
};

// Chatbot message status
export const CHATBOT_MESSAGE_STATUS = {
  SENDING: "sending",
  SENT: "sent",
  ERROR: "error",
};

// DefaultView display constants
export const DEFAULT_VIEW_TEXT = {
  DEFAULT_TITLE: "Amazon Meetings Assistant",
  STOPPED_TITLE: "Amazon Meetings Assistant stopped",
  STOPPED_SUBTITLE: "You'll receive a meeting summary when it's ready.",
  ATTENDEE_SUBTITLE: "Meeting organizers can turn on meeting summary.",
};

// Theme colors
export const THEME_COLOR = {
  TEAL_GREEN: "#006D5B",
  LIGHT_TEAL: "#AFE8D7",
  SEAFOAM_GREEN: "#55AA96",
  MID_GRAY: "#575F67",
};
